import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import { DeleteAutomationCallable } from "@/action-dialog/callables";
import type { FlowSchedule } from "@cohesive/api-client";
import toast from "react-hot-toast";

export interface DeleteAutomationParams {
  schedule: FlowSchedule;
  deleteFlowSchedule: {
    mutate: (
      flowScheduleId: string,
      options?: {
        onSuccess?: () => void;
        onError?: () => void;
      },
    ) => void;
  };
  /** Extra side effects after a successful delete (e.g. close the open pane). */
  onSuccess?: (schedule: FlowSchedule) => void | Promise<void>;
}

/**
 * Hard delete behind a one-decision confirm. No undo toast — automations have
 * no trash, so there is nothing to restore.
 */
export function runDeleteAutomationWorkflow(
  params: DeleteAutomationParams,
): Promise<boolean> {
  const { schedule, deleteFlowSchedule, onSuccess } = params;

  return withActionDialogLock(() =>
    DeleteAutomationCallable.call({
      name: schedule.name,
      mutationFn: async (call) => {
        await new Promise<void>((resolve, reject) => {
          deleteFlowSchedule.mutate(schedule.id, {
            onSuccess: () => resolve(),
            onError: () => {
              toast.error("Failed to delete automation.");
              reject(new Error("delete failed"));
            },
          });
        });
        await onSuccess?.(schedule);
        call.end(true);
      },
    }),
  );
}
